export const Signup = 'SIGNUP'
